import { ComponentProps } from '@/types/cms';
import BannerNoticeSkeleton from './skeleton';
import Container from '../Layout/container';
import ImageLazy from '@/components/common/LazyLoad/image-lazy';
import withFetch from '../../hooks/fetch';
import ImpTracker from '@/components/common/ImpTracker';
import useImpressionT2 from '@/tracks/useImpressionT2';
import useClickActionT2 from '@/tracks/useClickActionT2';
import { BannerType } from '@/constants/track';

const BannerNotice: React.FC<ComponentProps> = props => {
  let { cmsComponentKey, componentPosition, properties, postUrl, isStatic } = props;
  const eventKey = properties?.event_key || cmsComponentKey;
  const { bannerImpression } = useImpressionT2();
  const { bannerClick } = useClickActionT2();
  const { data, load } = withFetch({
    data: props.data,
    isStatic: isStatic ?? false,
    postUrl: postUrl
    // componentDataSourceKey
  });

  let dataList = data?.carousel || [];
  if (load) {
    return (
      <Container>
        <BannerNoticeSkeleton />
      </Container>
    );
  }
  if (dataList?.length) {
    return (
      <Container className="relative z-10">
        {dataList?.map((item, index) => {
          return (
            <a
              href={item.link_url}
              className="block text-[#333333] mb-2.5"
              key={index}
              aria-label={`Notice banner item ${index}`}>
              <ImpTracker
                impTrackingT2={() => {
                  bannerImpression({
                    mod_nm: eventKey,
                    mod_pos: componentPosition,
                    co: {
                      banner_pos: index,
                      banner_type: BannerType.homeBannerLine,
                      url: item?.link_url
                    }
                  });
                }}
                clickTrackingT2={() => {
                  bannerClick({
                    mod_nm: eventKey,
                    mod_pos: componentPosition,
                    co: {
                      banner_pos: index,
                      banner_type: BannerType.homeBannerLine,
                      url: item?.link_url
                    }
                  });
                }}>
                <ImageLazy
                  placeholder={
                    <div className="w-full h-[calc(68_*_100vw_/_375)] rounded-400 bg-surface-200-bg skeleton" />
                  }
                  className="w-full h-[calc(68_*_100vw_/_375)] rounded-400"
                  src={item.img_url}
                />
              </ImpTracker>
            </a>
          );
        })}
      </Container>
    );
  }
  return null;
};

export default BannerNotice;
